export default __webpack_public_path__ + "static/media/sims-table.479aaa69.png";